import { useDispatch } from 'react-redux'
import cnames from 'classnames'
import { snakecaseKeys } from 'Utils/objects'
import { useStayDates } from 'Checkout/Hooks/useStayDates'
import { searchFilterUpdate } from 'Checkout/Redux/Actions/Search'
import { useAccommodationOptionsClasses } from 'Checkout/Hooks/useAccommodationOptionsClasses'
import useRouter from 'Checkout/Hooks/useRouter'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const AccommodationOptions = ({ groupButtons }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const { checkOut } = useStayDates()
  const { btnDailyClasses, btnNightly, buttonsContainer } = useAccommodationOptionsClasses(groupButtons)
  const containerClassname = cnames('accommodation-options mb-4', {
    'd-flex justify-content-center': groupButtons,
  })

  const setUseDaily = value => {
    const accommodation = value ? 'daily' : 'overnight'
    const optionalSearch = { checkOut: value ? null : checkOut }
    const optionalUrl = snakecaseKeys(optionalSearch)
    dispatch(searchFilterUpdate({ accommodation, dayUse: value, ...optionalSearch }))
    router.replaceQuery({ accommodation, ...optionalUrl })
  }

  return (
    <div className={containerClassname}>
      {!groupButtons && <p className="fw-normal mb-1 text-black">What are you looking for?</p>}

      <div className={buttonsContainer} role={groupButtons ? 'group' : ''}>
        <button className={btnNightly} onClick={() => setUseDaily(false)} type="button">
          <FontAwesomeIcon className="me-2" icon="cloud-moon" size="lg" />

          {groupButtons ? 'Overnight' : 'Overnight Accommodations'}
        </button>

        <button className={btnDailyClasses} onClick={() => setUseDaily(true)} type="button">
          <FontAwesomeIcon className="me-2" icon="sun" size="lg" />

          {groupButtons ? 'Daily' : 'Daily Accommodations'}
        </button>
      </div>
    </div>
  )
}

AccommodationOptions.defaultProps = {
  groupButtons: false,
}

export default AccommodationOptions
